import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import ParkingMeterDTO from '../../../dto/ParkingMeterDTO';
import SelectInput from '../../../components/fields/SelectInput/SelectInput';
import RadioButton from '../../../components/fields/RadioButton/RadioButton';
import {
  PARKING_METER_AVAILABLE_STATUS,
  PARKING_METER_STATUS,
  pssKeysT, printerKeysT, powerKeysT, paymentKeysT, lowDoorKeysT, upDoorKeysT, lowLockKeysT, upLockKeysT,
} from '../constants';
import { optionClassFormatter } from '../../../utils/formatters';
import CheckBoxInputWithLabel from '../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';
import FilterDTO from '../../../dto/FilterDTO';
import FieldWithAttributeDTO from '../../../components/fields/Abstract/FieldWithAttributeDTO';
import { getCheckClassByName } from '../parking-meter-utils';

export function FilterPresets(props) {
  const {
    keys = [],
    errorKeys = [],
    warningKeys = [],
    setValue,
    getValues,
    resetField,
  } = props;

  const isSelectOnly = (values = []) => values.every(e => getValues(e));

  const selectPreset = isError => () => {
    const keys = isError ? errorKeys : warningKeys;
    const isSelected = isSelectOnly(keys);
    const formData = getValues();

    for (let i = 0; i < keys.length; i++) {
      const current = keys[i];
      if (!isSelected) {
        setValue(current, !formData[current] ? keys.includes(current) : formData[current]);
      } else {
        resetField(current);
      }
    }
  };

  return (
    <div className="form-block-presets">
      <Button
        className={classNames('presets-button', { active: isSelectOnly(errorKeys, keys) })}
        variant="secondary"
        onClick={selectPreset(true)}
      >Ошибка
      </Button>
      <Button
        className={classNames('presets-button', { active: isSelectOnly(warningKeys, keys) })}
        variant="secondary"
        onClick={selectPreset(false)}
      >Некритическая поломка
      </Button>
    </div>
  );
}

export default function ParkingMeterFilterForm(props) {
  const {
    onHide, resetField, meta, reset = () => {}, zones, register, getValues, setValue, defaultValues,
  } = props;
  const DTO = new ParkingMeterDTO();
  const filterDto = new FilterDTO();
  const attributes = DTO.getAttributesByName();
  const filterAttributes = filterDto.getAttributesByName();

  const availableStatusOptions = Object.values(PARKING_METER_AVAILABLE_STATUS).map(v => ({ value: Number(v), nameId: `parking.meter.available_status.${v}` })).reverse();
  const statusOptions = Object.values(PARKING_METER_STATUS).map(v => ({ value: Number(v), nameId: `parking.meter.status.${v}` })).reverse();
  const zonesOptions = zones.map(i => ({ name: i, value: i }));
  const [scroll, setScroll] = useState(null);
  useEffect(() => {
    const a = new window.IScroll('#filter-scroll-wrapper', {
      scrollbars: true,
      mouseWheel: true,
      preventDefault: false,
      interactiveScrollbars: true,
    });
    setScroll(a);
  }, []);
  useEffect(() => {
    if (scroll) {
      scroll.refresh();
    }
  }, [zones]);

  const renderCheckBox = (name, index) => (
    <FieldWithAttributeDTO
      key={index}
      type="text"
      component={CheckBoxInputWithLabel}
      dtoObject={filterAttributes[name]}
      className={getCheckClassByName(name)}
      withLabel
      addPlaceholder
      inputProps={{
        value: getValues(name),
        ...register(name),
        onChange: () => setValue(name, !getValues(name)),
      }}
    />
  );

  const clear = () => {
    reset(defaultValues);
  };

  return (
    <Dialog
      className={classNames('parking-meter-full-filter')}
      onClose={onHide}
      open
    >
      <DialogTitle
        className="pmff-title"
        title={(
          <>
            <div className="pmff-title-text f2">Фильтры</div>
            <div className="pmff-close-wrapper">
              <Icons width={14} height={14} customIcon icon="clear" className="pmff-close" onClick={onHide} />
            </div>
          </>
      )}
      />
      <DialogContent className="pff-content">
        <div className="scroll-wrapper filter-scroll-wrapper" id="filter-scroll-wrapper">
          <div className="scroll">
            <form>
              <FieldWithAttributeDTO
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.zbx_address}
                inputProps={{
                  value: getValues('address'),
                  ...register('address'),
                }}
              />
              <FieldWithAttributeDTO
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.host}
                className="filter-margin"
                inputProps={{
                  value: getValues('host'),
                  ...register('host'),
                }}
              />
              <FieldWithAttributeDTO
                type="text"
                component={SelectInput}
                dtoObject={attributes.zbx_zone}
                className="filter-margin"
                withLabel
                addPlaceholder
                options={zonesOptions}
                inputProps={{
                  value: getValues('zbx_zone'),
                  ...register('zbx_zone'),
                }}
              />
              <FieldWithAttributeDTO
                type="text"
                component={RadioButton}
                dtoObject={attributes.available_status}
                className="filter-margin"
                withLabel
                addPlaceholder
                options={availableStatusOptions}
                optionClassFormatter={optionClassFormatter}
                inputProps={{
                  ...register('available_status'),
                  value: Number(getValues('available_status')),
                  onChange: e => {
                    setValue('available_status', Number(e.target.value));
                  },
                }}
              />
              <FieldWithAttributeDTO
                type="text"
                component={RadioButton}
                dtoObject={attributes.status}
                className="filter-margin"
                withLabel
                addPlaceholder
                options={statusOptions}
                optionClassFormatter={optionClassFormatter}
                inputProps={{
                  ...register('status'),
                  value: Number(getValues('status')),
                  onChange: e => {
                    setValue('status', Number(e.target.value));
                  },
                }}
              />
              <div className="form-block-label filter-margin">
                <div className="form-block-label-text">Нижняя дверь</div>
                <div
                  className="form-block-label-button"
                  onClick={() => reset({ ...getValues(), ...lowDoorKeysT })}
                >Сбросить
                </div>
              </div>
              {Object.keys(lowDoorKeysT).map(renderCheckBox)}

              <div className="form-block-label filter-margin">
                <div className="form-block-label-text">Верхняя дверь</div>
                <div
                  className="form-block-label-button"
                  onClick={() => reset({ ...getValues(), ...upDoorKeysT })}
                >Сбросить
                </div>
              </div>
              {Object.keys(upDoorKeysT).map(renderCheckBox)}
              <div className="form-block-label filter-margin">
                <div className="form-block-label-text">Замок на нижней двери</div>
                <div
                  className="form-block-label-button"
                  onClick={() => reset({ ...getValues(), ...lowLockKeysT })}
                >Сбросить
                </div>
              </div>
              {Object.keys(lowLockKeysT).map(renderCheckBox)}
              <div className="form-block-label filter-margin">
                <div className="form-block-label-text">Замок на верхней двери</div>
                <div
                  className="form-block-label-button"
                  onClick={() => reset({ ...getValues(), ...upLockKeysT })}
                >Сбросить
                </div>
              </div>
              {Object.keys(upLockKeysT).map(renderCheckBox)}
              <div className="form-block-label filter-margin">
                <div className="form-block-label-text">Связь с парковочным сервером</div>
                <div
                  className="form-block-label-button"
                  onClick={() => reset({ ...getValues(), ...pssKeysT })}
                >Сбросить
                </div>
              </div>
              <FilterPresets
                keys={Object.keys(pssKeysT)}
                errorKeys={['PSS_ERROR', 'PSS_UNREGISTERED']}
                warningKeys={['PSS_UNKNOWN']}
                setValue={setValue}
                getValues={getValues}
                reset={reset}
                resetField={resetField}
              />
              {Object.keys(pssKeysT).map(renderCheckBox)}
              <div className="form-block-label filter-margin">
                <div className="form-block-label-text">Принтер</div>
                <div
                  className="form-block-label-button"
                  onClick={() => reset({ ...getValues(), ...printerKeysT })}
                >Сбросить
                </div>
              </div>
              <FilterPresets
                keys={Object.keys(printerKeysT)}
                errorKeys={['PS_ERROR', 'PS_PAPER_EMPTY']}
                warningKeys={['PS_PAPER_LOW', 'PS_UNKNOWN']}
                setValue={setValue}
                getValues={getValues}
                reset={reset}
                resetField={resetField}
              />
              {Object.keys(printerKeysT).map(renderCheckBox)}
              <div className="form-block-label filter-margin">
                <div className="form-block-label-text">Контроллер питания</div>
                <div
                  className="form-block-label-button"
                  onClick={() => reset({ ...getValues(), ...powerKeysT })}
                >Сбросить
                </div>
              </div>
              <FilterPresets
                keys={Object.keys(powerKeysT)}
                errorKeys={['POWER_ERROR']}
                warningKeys={['POWER_LOW_POWER', 'POWER_UNKNOWN']}
                setValue={setValue}
                getValues={getValues}
                reset={reset}
                resetField={resetField}
              />
              {Object.keys(powerKeysT).map(renderCheckBox)}
              <div className="form-block-label filter-margin">
                <div className="form-block-label-text">Модуль оплаты</div>
                <div
                  className="form-block-label-button"
                  onClick={() => reset({ ...getValues(), ...paymentKeysT })}
                >Сбросить
                </div>
              </div>
              {Object.keys(paymentKeysT).map(renderCheckBox)}
            </form>
          </div>
        </div>
      </DialogContent>
      <DialogFooter className="pmff-footer">
        <div className="pmff-footer-text">Нашли {meta && meta.total ? meta.total : 0} паркоматов</div>
        <div className="pmff-footer-buttons">
          <Button className="pmff-clear-data" variant="secondary" onClick={clear}>Сбросить</Button>
          <Button className="pmff-clear-show" onClick={onHide}>Показать</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
